import styled from "styled-components";

export const CVStyled = styled.div`
  height: 100vh;
  
`;